import React, { useState } from 'react';
import './Testimonial.css';
import Layout from '../PageLayout/Layout';

const testimonials = [
  {
    text: "Highwatch cut our onboarding time in half. New hires now get answers instantly — without chasing docs or pinging 5 people.",
    name: "Darrell Steward",
    title: "Developer at Fr. Design Studio",
    avatar: "/images/Darrell.png",
  },
  {
    text: "We used to lose 2–3 hours weekly just trying to locate shipment SOPs. Now Highwatch fetches them in seconds.",
    name: "John Smith",
    title: "Operations Lead at PixelForge",
    avatar: "/images/John.png",
  },
  {
    text: "I asked Highwatch where our last legal decision on pricing was. It pulled the exact Confluence note — with the timestamp.",
    name: "Micheal Taylor",
    title: "IT Manager at GHI Solutions",
    avatar: "/images/Micheal.png",
  }
];

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(1);

  const handlePrev = () => {
    setActiveIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  return (
    <>
      {/* Legacy testimonials — kept for mobile reuse if mounted */}
      <section className="testimonials testimonials-mobile">
        <Layout>
          <div className="testimonials-wrapper">
            <div className="testimonials-header">
              <span className="badge mb-6"><img src="/icons/message-chatbot.svg" alt="icon"/>Testimonials</span>
              <h2>Trusted by teams who move fast and think smarter.</h2>
              <p>
                From clinics to construction sites, CoreLink helps teams save hours every week by turning
                scattered information into instant answers — right where they work.
              </p>
            </div>

            <div className="testimonials-cards-wrapper">
              <button className="arrow" onClick={handlePrev}>←</button>

              <div className="testimonials-cards">
                {testimonials.map((item, index) => {
                  const isActive = index === activeIndex;
                  const isAdjacent =
                    index === (activeIndex + 1) % testimonials.length ||
                    index === (activeIndex - 1 + testimonials.length) % testimonials.length;

                  return (
                    <div
                      key={index}
                      className={`card ${isActive ? 'active' : isAdjacent ? 'adjacent' : 'hidden'}`}
                    >
                      <p>{item.text}</p>
                      <div className="user">
                        {item.avatar && <img src={item.avatar} alt="avatar" />}
                        <div>
                          <strong>{item.name}</strong>
                          <span>{item.title}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              <button className="arrow" onClick={handleNext}>→</button>
            </div>

            <div className="dots">
              {testimonials.map((_, i) => (
                <span
                  key={i}
                  className={`dot ${i === activeIndex ? 'active' : ''}`}
                  onClick={() => setActiveIndex(i)}
                ></span>
              ))}
            </div>
          </div>
        </Layout>
      </section>

      {/* Desktop Voices — reserved slots only */}
      <section className="hw-voices">
        <div className="hw-voices__header">
          <p className="hw-voices__eyebrow">VOICES</p>
          <h2>Others assist. Highwatch orchestrates.</h2>
        </div>
        <div className="hw-voices__grid">
          {[0, 1, 2].map((slot) => (
            <article key={slot} className="hw-voices__card">
              <p className="hw-voices__reserved">RESERVED SLOT</p>
              <p className="hw-voices__note">
                Reserved for real client quote — do not fabricate names or quotes.
              </p>
              <div className="hw-voices__user">
                <span className="hw-voices__avatar" />
                <span className="hw-voices__lines">
                  <i />
                  <i />
                </span>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
